import { Paper, Tab, Tabs } from '@mui/material';
import { useBillingTabs } from 'components/OrderForm/BillingShipping/hooks/useBillingTabs';
import { useBillingShippingStyles } from 'components/OrderForm/BillingShipping/styles';
import { ExistingContactForm } from 'components/OrderForm/BillingShipping/BillingTabs/ExistingContactForm';
import { TabPanel } from 'components/Shared/TabPanel';
import { AddBillingContactForm } from 'components/OrderForm/BillingShipping/BillingTabs/AddBillingContactForm';
import {
  BLANKET_PURCHASE_ORDER_TAB_VALUE,
  EXISTING_BILLING_INFO_TAB_VALUE,
  PO_NUMBER_INFO_TAB_VALUE,
} from 'components/OrderForm/BillingShipping/utilities/constants';
import { BlanketPurchaseOrders } from 'components/OrderForm/BillingShipping/BillingTabs/BlanketPurchaseOrders/BlanketPurchaseOrders';

export const BillingTabs = () => {
  const { classes } = useBillingShippingStyles();
  const {
    billingTabSelected,
    handleBillingTabChange,
    teamUUID,
    handleAddBillingSuccess,
    onBlanketPurchaseOrderSelect,
    billingContacts,
  } = useBillingTabs();

  return (
    <Paper className={classes.paper}>
      <Tabs
        value={billingTabSelected}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleBillingTabChange}
      >
        <Tab label="PO Number" />
        <Tab label="Blanket Purchase Orders" />
        <Tab label="Existing Billing Info" />
      </Tabs>
      <TabPanel value={billingTabSelected} index={PO_NUMBER_INFO_TAB_VALUE}>
        {!!teamUUID && (
          <AddBillingContactForm
            onAfterSuccessSubmit={handleAddBillingSuccess}
          />
        )}
      </TabPanel>
      <TabPanel
        value={billingTabSelected}
        index={BLANKET_PURCHASE_ORDER_TAB_VALUE}
      >
        <BlanketPurchaseOrders onChange={onBlanketPurchaseOrderSelect} />
      </TabPanel>
      <TabPanel
        value={billingTabSelected}
        index={EXISTING_BILLING_INFO_TAB_VALUE}
      >
        <ExistingContactForm billingContacts={billingContacts} />
      </TabPanel>
    </Paper>
  );
};
